(function () {
  'use strict';

  function odrCalendarFactory (Common, odrDistributionFactory, Translation) {
    const factory = {};

    factory.years = [];
    factory.dateExceptions = [];

    function isHoliday (date, daysToAdd) {
      let isHoliday = false;
      let dateToBeChecked = angular.copy(date);

      if (daysToAdd) {
        dateToBeChecked = dateToBeChecked.setDate(dateToBeChecked.getDay() + daysToAdd);
      }

      dateToBeChecked = moment(dateToBeChecked).format('MM-DD-YYYY');

      isHoliday = (factory.holidays || []).filter((item) => {
        return moment(item.date).format('MM-DD-YYYY') === dateToBeChecked;
      }).length;

      return isHoliday;
    }

    function isWeekend (date) {
      return date.getDay() === 6 || date.getDay() === 0;
    }

    // this is where to get the start date for which the user can select for the delivery date
    function getDateForEnableStart (product) {
      const earliestBookingDate = factory.dateExceptions[0].date;
      return moment(earliestBookingDate).toDate();
    }

    function setSelectedDate (date) {
      factory.selectedDate = Common.get('productDelivery.deliveryDate', date);
      setWeekNumber(date);
    }

    function setWeekNumber (date, fromODR) {
      if (!date && !fromODR) {
        return;
      }

      const weekNumber = !fromODR ? moment(date).week() : null;
      const year = !fromODR ? moment(date).year(): null;
      Common.set('weekInfo', {
        weekNumber,
        highTraffic: !fromODR ? isHighTrafficWeek(weekNumber, year) : false // set default to false when
      });
    }

    const highTrafficWeeks = [
      {
        year: 2025,
        weeks: [5, 9, 13, 18, 22, 26, 35, 39, 44, 48]
      }
    ];

    function isHighTrafficWeek (week, year) {
      const weekObject = highTrafficWeeks.find((weekObject) => {
        return weekObject.year === year;
      });

      if (!weekObject) {
        return false;
      }

      return weekObject.weeks.indexOf(week) > -1;
    }


    function setDisabled (date) {
      const isOdrDate = factory.checkDateException(date.date);
      return !isOdrDate;
    }

    function checkDateException (date) {
      const dateToBeChecked = moment(date).format('YYYY-MM-DD');
      const today = moment();
      return factory.dateExceptions.find((item) => {
        const lastBookingDateWithTime = moment(`${item.lastBookingDate} 18:00`, 'YYYY-MM-DD HH:mm');
        const isBeforeClosing = today.isSameOrBefore(lastBookingDateWithTime, 'hour');
        return dateToBeChecked === item.date && isBeforeClosing;
      }) || false;
    }

    function getClass (date) {
      const dayToCheck = new Date(date.date);
      const dayToCheckSeconds = dayToCheck.setHours(0, 0, 0, 0);
      const isDateException = checkDateException(date.date);
      const classes = {
        exclusive: 'odr-exclusive-bg'
      };

      let currentDate = angular.copy(factory.currentDate);
      currentDate = currentDate.setHours(0, 0, 0, 0);

      if (currentDate === dayToCheckSeconds) {
        return 'dp-current-date';
      }

      // override date here
      if (isDateException) {
        return classes[isDateException.service];
      }
    }

    function setDatepickerOptions () {
      const lastItemIndex = factory.dateExceptions.length - 1;
      factory.datepickerOptions = {
        showWeeks: false,
        datePickerMode: 'day',
        maxMode: 'day',
        numberOfMonths: 2,
        dateDisabled: setDisabled,
        minDate: factory.dateExceptions[0].lastBookingDate,
        min: factory.dateExceptions[0].lastBookingDate,
        maxDate: factory.dateExceptions[lastItemIndex].lastBookingDate,
        max: factory.dateExceptions[lastItemIndex].lastBookingDate,
        customClass: getClass,
        startingDay: 1
      };
    }

    function initializeCalendar (product) {
      const firstAvailableDate = moment(factory.dateExceptions[0].date).toDate();

      factory.currentDate = new Date();
      factory.startOfSelection = firstAvailableDate;
      factory.calendarDates = [{
        'date': factory.currentDate,
        'class': 'dp-current-date'
      }];

      getDateForEnableStart(product);
      setSelectedDate(firstAvailableDate);
      setDatepickerOptions();
    }

    function getCalendarClasses () {
      return factory.calendarDates;
    }

    function getDatepickerOptions () {
      return factory.datepickerOptions;
    }

    function addYear (year) {
      // factory.years.push(year);
    }

    function setDate (changedModel, cb) {
      factory.selectedDate = changedModel;

      Common.set('productDelivery.deliveryDate', factory.selectedDate);
      setWeekNumber(factory.selectedDate);

      cb(changedModel);
    }

    function getFormattedSelectedDate () {
      return moment(Common.get('productDelivery.deliveryDate', factory.selectedDate))
        .locale(pnTopbar.language)
        .format('DD MMMM YYYY');
    }

    function getSubmissionDeadline (product) { //Get submission days by Service
      const service = getDeliveryTypeKey();
      const prodDays = odrDistributionFactory.getDeliveryDaysByService(service) || 3; // default to 3 for stf printing
      const deliveryDate = moment(angular.copy((product || {}).deliveryDate || factory.selectedDate));
      const time = odrDistributionFactory.getSelectedCenterTime();

      let x = 1;
      while (x <= prodDays) {
        deliveryDate.subtract(1, 'days');
        // should not be a weekend nor holiday
        if (!isWeekend(new Date(deliveryDate)) && !isHoliday(new Date(deliveryDate))) {
          x++;
        }
      }
      return time + ' ' + deliveryDate.locale(pnTopbar.language).format('dddd DD MMMM');
    }

    function getDeliveryTypeKey () {
      const type = 'DISTRIBUTION_PAGE_ODR_EXCLUSIVE_LABEL'; // defaults to standard
      // this method is called within a translation key
      // hopefully it will be updated when switching language
      return Translation.translate(type).value;
    }

    function isCompany () {
      return Common.get('recipients.targetType', 'INDIVIDUALS') === 'COMPANIES';
    }

    function getDatWithPrevBookingCondition (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      return factory.dateExceptions.filter(item => item.prevBookingSubmission
        && item.date === formattedDate)[0] || false;
    }

    function getSubmissionDays (defaultDay, selectedDate) {
      const isExempted = factory.getDatWithPrevBookingCondition(selectedDate);
      const currentDate = moment().format('YYYY-MM-DD');
      if (isExempted && currentDate === isExempted.bookingDate && isExempted.prevBookingSubmission) {
        return defaultDay - 1;
      }

      return defaultDay;
    }

    function getService (defaultService, deliveryDate) {
      const isExempted = factory.checkDateException(deliveryDate);

      if (!isExempted) {
        return defaultService;
      } else {
        return isExempted.service;
      }
    }

    factory.initializeCalendar = initializeCalendar;
    factory.setSelectedDate = setSelectedDate;
    factory.getCalendarClasses = getCalendarClasses;
    factory.getDatepickerOptions = getDatepickerOptions;
    factory.addYear = addYear;
    factory.setDate = setDate;
    factory.getFormattedSelectedDate = getFormattedSelectedDate;
    factory.getDeliveryTypeKey = getDeliveryTypeKey;
    factory.getSubmissionDeadline = getSubmissionDeadline;
    factory.getDeliveryTypeKey = getDeliveryTypeKey;
    factory.isCompany = isCompany;
    factory.checkDateException = checkDateException;
    factory.getSubmissionDays = getSubmissionDays;
    factory.getDatWithPrevBookingCondition = getDatWithPrevBookingCondition;
    factory.getService = getService;
    factory.getDateForEnableStart = getDateForEnableStart;
    factory.setWeekNumber = setWeekNumber;

    return factory;
  }

  angular.module('web2print.whereTo')
    .factory('odrCalendarFactory', odrCalendarFactory);
})();
